<script>
    import {elementDetails} from '../workspacesStore.js';
    export let rows = $elementDetails ? ($elementDetails.history? $elementDetails.history : []) : [];
</script>

<style>
    .created_date {
        font-size: 14px;
        color:#6C757D;
        margin-bottom: 12px;
    }

    .details {
        padding-top: 10px;
        margin-bottom: 24px;
    }
</style>

<table>
    {#each rows as row}
        <div><b>{row.user}</b></div>
        <div class="created_date">{row.created_date}</div>
        <div class="details">{row.details}</div>
    {/each}
</table>
